module.exports = __webpack_public_path__ + "img/brown leather bifold wallet on gray concrete floor.a698109a.png";